import { removeTableAction } from "./atom.actions.js";
import { asapScheduler, observeOn } from "rxjs";
//#region src/engine/modules/table/hooks.ts
var endDrawFromRemovedTableHook = (action$, getState) => action$.pipe(observeOn(asapScheduler)).subscribe(() => {
	const { doc, editor } = getState();
	const start = editor.drawRelationship?.start;
	if (!start || doc.tableIds.includes(start.tableId)) return;
	editor.drawRelationship = null;
});
var hooks = [[[removeTableAction], endDrawFromRemovedTableHook]];
//#endregion
export { hooks };
